/*
  "Byg din egen"-vælger på bundle-produkterne.

  Vælgeren holder styr på hvilke dufte der ligger i hvilken plads, og skriver
  dem som skjulte felter (properties[...]) der peger på Dawns produktformular
  via form-attributten. Dawn sender dem selv med til /cart/add.

  Købsknappen spærres på to måder med vilje:
    - aria-disabled, som er den grænse Dawns egen product-form.js kigger på
    - en klik-lytter i capture-fasen, fordi Dawn fjerner aria-disabled igen
      efter hvert forsøg, og knappen ellers ville være åben bagefter
*/
if (!customElements.get('ahlam-bundle-picker')) {
  customElements.define(
    'ahlam-bundle-picker',
    class AhlamBundlePicker extends HTMLElement {
      connectedCallback() {
        this.slotCount = parseInt(this.dataset.slots, 10) || 3;
        // Ikke this.prefix: Element har allerede en prefix-getter uden setter,
        // og tildelingen kaster, så hele elementet aldrig bliver sat op.
        this.propertyPrefix = this.dataset.propertyPrefix || 'Fragrance';
        this.chosen = new Array(this.slotCount).fill(null);

        this.optionsList = this.querySelector('[data-ahlam-picker-options]');
        this.noResults = this.querySelector('[data-ahlam-picker-noresults]');
        this.slots = Array.from(this.querySelectorAll('[data-ahlam-picker-slot]'));
        this.status = this.querySelector('[data-ahlam-picker-status]');
        this.inputs = this.querySelector('[data-ahlam-picker-inputs]');
        this.searchInput = this.querySelector('[data-ahlam-picker-search]');
        this.submitButton = document.getElementById(this.dataset.submitId);

        this.addEventListener('click', this.onClick.bind(this));
        if (this.searchInput) {
          this.searchInput.addEventListener('input', this.onSearch.bind(this));
        }
        if (this.submitButton) {
          this.submitButton.addEventListener('click', this.onSubmitClick.bind(this), true);
        }

        this.render();
      }

      get filledCount() {
        return this.chosen.filter(Boolean).length;
      }

      get isComplete() {
        return this.filledCount === this.slotCount;
      }

      onClick(event) {
        const remove = event.target.closest('[data-ahlam-picker-remove]');
        if (remove) {
          const slot = remove.closest('[data-ahlam-picker-slot]');
          this.chosen[this.slots.indexOf(slot)] = null;
          this.render();
          return;
        }

        const option = event.target.closest('[data-ahlam-picker-option]');
        if (!option) return;

        const next = this.chosen.indexOf(null);
        if (next === -1) {
          this.flashFull();
          return;
        }

        this.chosen[next] = { name: option.dataset.name, image: option.dataset.image };
        this.render();
      }

      onSubmitClick(event) {
        if (this.isComplete) return;
        event.preventDefault();
        event.stopPropagation();
        this.flashIncomplete();
      }

      onSearch() {
        const term = this.searchInput.value.trim().toLowerCase();
        let visible = 0;

        this.optionsList.querySelectorAll('[data-ahlam-picker-option]').forEach((option) => {
          const match = term === '' || option.dataset.search.indexOf(term) !== -1;
          option.closest('.ahlam-picker__option').hidden = !match;
          if (match) visible += 1;
        });

        if (this.noResults) this.noResults.hidden = visible > 0;
      }

      flashFull() {
        this.setStatus(this.dataset.fullText, true);
      }

      flashIncomplete() {
        this.setStatus(this.incompleteText(), true);
      }

      incompleteText() {
        const missing = this.slotCount - this.filledCount;
        return (this.dataset.incompleteText || '').replace('[n]', missing);
      }

      setStatus(text, isWarning) {
        if (!this.status) return;
        this.status.textContent = text;
        this.status.classList.toggle('ahlam-picker__status--warning', Boolean(isWarning));
        this.status.hidden = !text;
      }

      render() {
        this.slots.forEach((slot, index) => {
          const pick = this.chosen[index];
          const text = slot.querySelector('[data-ahlam-picker-slot-text]');
          const thumb = slot.querySelector('[data-ahlam-picker-slot-thumb]');
          const plus = slot.querySelector('[data-ahlam-picker-slot-plus]');
          const remove = slot.querySelector('[data-ahlam-picker-remove]');

          slot.classList.toggle('is-filled', Boolean(pick));

          if (pick) {
            text.textContent = pick.name;
            if (pick.image) {
              thumb.src = pick.image;
              thumb.hidden = false;
            }
            plus.hidden = true;
            remove.hidden = false;
          } else {
            text.textContent = (this.dataset.slotLabel || '').replace('[n]', index + 1);
            thumb.removeAttribute('src');
            thumb.hidden = true;
            plus.hidden = false;
            remove.hidden = true;
          }
        });

        this.writeInputs();
        this.syncSubmit();

        if (this.isComplete) {
          this.setStatus(this.dataset.completeText, false);
        } else {
          this.setStatus(this.incompleteText(), false);
        }
      }

      writeInputs() {
        this.inputs.textContent = '';

        this.chosen.forEach((pick, index) => {
          if (!pick) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[' + this.propertyPrefix + ' ' + (index + 1) + ']';
          input.value = pick.name;
          input.setAttribute('form', this.dataset.formId);
          this.inputs.appendChild(input);
        });
      }

      syncSubmit() {
        if (!this.submitButton) return;
        this.submitButton.setAttribute('aria-disabled', this.isComplete ? 'false' : 'true');
        this.submitButton.classList.toggle('ahlam-picker-blocked', !this.isComplete);
      }
    }
  );
}
